/* eslint-disable quotes */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import { Button, Spin } from "antd";

import {
  clearBarcode,
  clearPostShipment,
  clearCreateChildShipment,
} from "../../actionsMethods/cashBookingMethods";

import success from "../../assests/images/SVG/success@2x.svg";
import booking_details from "../../assests/images/booking_details.svg";
import whatsapp from "../../assests/images/whatsapp.svg";
import warning from "../../assests/images/warning.svg";

import "./style.scss";

const BookSuccessfull = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const status = false;
  // const [id, setId] = useState({
  //   awbNumber: 22121,
  //   receiverMobilenumber: 8951499596,
  //   senderMobileNumber: 8280998240,
  // });
  const [id, setId] = useState();

  const [loading, setLoading] = useState(false);
  let deactivate = !status ? "booking_invoice_details" : "deactivate";

  useEffect(() => {
    setId(JSON.parse(localStorage.getItem("details")));
    dispatch(clearCreateChildShipment());
    // dispatch(clearBarcode());
    // dispatch(clearPostShipment());
    // localStorage.removeItem("details");

    localStorage.removeItem("allFiles");
    localStorage.removeItem("childAwbNumber");
    localStorage.setItem("childNumber", false);
  }, []);

  const handler = () => {
    dispatch(clearBarcode());
    dispatch(clearPostShipment());
    navigate("/cash-booking");
    localStorage.removeItem("details");
    localStorage.removeItem("allFiles");
    localStorage.removeItem("childAwbNumber");
    localStorage.setItem("childNumber", false);
  };

  const handlerDone = () => {
    dispatch(clearBarcode());
    dispatch(clearPostShipment());
    navigate("/dashboard");
    localStorage.removeItem("details");
    localStorage.removeItem("allFiles");
    localStorage.removeItem("childAwbNumber");
    localStorage.setItem("childNumber", false);
  };

  const sendSms = async () => {
    try {
      let res = await axios.get(
        `https://pgapi.vispl.in/fe/api/v1/send?username=shremotpg.trans&password=uNIvT&unicode=false&from=SMCSPL&dltPrincipalEntityId=1001569800000012636&dltContentId=1007163186467531163&text=Shree Maruti Courier
        Your shipment ${id?.awbNumber} is booked with Shree Maruti Courier. To track your shipment you can visit https://www.shreemaruticourier.com/tracking/?d=${id?.awbNumber}&to=${id?.receiverMobilenumber}`
      );
      if (res.data) {
        // console.log(res, "resssss");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const sendWhatApp = async () => {
    try {
      let res = await axios.get(
        ` http://wa3.nuke.co.in/admin/sendwhatsapp/insert_whatsapp_api1?username=maruticourier&password=*********&mobile_no=${id?.senderMobileNumber}&message=message_to_consigner_while_cash_booking_ft_vp_service_v2_2&uploaded1=whatsapp/2023-01-02_09:53:33842368-cash-invoice.pdf&uploaded2=FastTrack&uploaded3=${id?.awbNumber}&uploaded4=ASF&uploaded5=DELHI&uploaded6=https://www.shreemaruti.com/dw/?a=R98s3K&uploaded7=https://www.shreemaruti.com/dw/?a=S79s3P&uploaded9=tracking/?d=${id?.awbNumber}`
      );
      // console.log(res, "status");

      if (res.data) {
        setLoading(false);
        // console.log(res, "2222222222222");
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id === undefined || null) {
      setLoading(true);
    } else {
      sendSms();
      sendWhatApp();
      setLoading(false);
    }
  }, [id]);

  return (
    <Spin spinning={loading}>
      <div className="booking-success">
        <div className="success-container">
          <div className="content">
            <img src={success} />
            <div className="message">
              <p>
                <strong>Booking successfully completed</strong>
              </p>
              <p className="order-id">
                for Order Id:&nbsp; <span>{id?.awbNumber}</span>
              </p>

              <div className={deactivate}>
                {!status ? (
                  <>
                    <img src={booking_details} />
                    <p>
                      &nbsp;&nbsp;Booking details sent to{" "}
                      {id?.senderMobileNumber}
                      &nbsp;
                    </p>
                  </>
                ) : (
                  <>
                    <img src={warning} />
                    <p>&nbsp;Failed to send booking information.&nbsp;</p>
                    <a>resend</a>
                  </>
                )}
              </div>
              <div className={`${deactivate} invoice-details`}>
                {!status ? (
                  <>
                    <img src={whatsapp} />

                    <p>
                      &nbsp; Invoice details sent to {id?.receiverMobilenumber}
                      &nbsp;
                    </p>
                  </>
                ) : (
                  <>
                    <img src={warning} />
                    <p>&nbsp;Failed to send booking information.&nbsp;</p>
                    <a>resend</a>
                  </>
                )}
              </div>
            </div>

            <div className="btn-cont">
              <Button onClick={handler} className="back-button">
                {"Add New Booking"}
              </Button>
              <Button type="primary" className="done" onClick={handlerDone}>
                Done
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default BookSuccessfull;
